var _defs, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIprsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 170,
    height: 49.469,
    viewBox: "0 0 170 49.469",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 7.261,
    y1: -65.734,
    x2: 8.263,
    y2: -65.734,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1659f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c83883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a93c85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 11.024,
    y1: -68.621,
    x2: 12.023,
    y2: -68.621,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dcdf93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#bbc85f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86a433"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311",
    transform: "translate(-218.259 -238.204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M549.293,266.858a3,3,0,0,0-3,2.992v.137a3.038,3.038,0,0,0,2.992,3c1.6,0,5-.094,7.22,2.129s1.972,5.439,1.972,7.091a3,3,0,0,0,2.992,3h.137a3.006,3.006,0,0,0,3-2.992V275.5c0-6.453-2.433-8.64-7.152-8.64Z",
    transform: "translate(-188.526 -16.468)",
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M590.22,256.536a2.99,2.99,0,0,0,3-2.974v-.136a3.008,3.008,0,0,0-2.992-3c-1.641,0-5.356.361-7.579-1.861-1.964-1.963-1.613-5.676-1.613-7.358a2.985,2.985,0,0,0-2.992-3h-.136a3.022,3.022,0,0,0-3.02,2.992v6.719c0,6.453,2.451,8.621,7.17,8.621Z",
    transform: "translate(-204.962)",
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M222.072,285.354h-3.134a.676.676,0,0,1-.679-.646v-2.843a.677.677,0,0,1,.679-.646h3.134a.648.648,0,0,1,.646.646v2.843A.647.647,0,0,1,222.072,285.354Zm-.1,20.644H219a.676.676,0,0,1-.646-.678v-16.9a.648.648,0,0,1,.646-.647h2.973a.648.648,0,0,1,.646.647v16.9A.676.676,0,0,1,221.975,306Z",
    transform: "translate(0 -24.722)",
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M245.987,314.814a24.364,24.364,0,0,1-3.1-.227v5.719a.648.648,0,0,1-.647.646h-2.971a.648.648,0,0,1-.647-.646V297.821c0-.485.13-.678.872-.872a27.535,27.535,0,0,1,6.494-.84c5.2,0,7.722,3.069,7.722,8.109v2.487C253.709,311.745,251.188,314.814,245.987,314.814Zm3.457-10.6c0-2.649-.678-4.62-3.457-4.62a18.891,18.891,0,0,0-3.1.226V311.1a27.04,27.04,0,0,0,3.1.226c2.778,0,3.457-1.97,3.457-4.619Z",
    transform: "translate(-11.702 -33.279)",
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M291.183,299.727a9.151,9.151,0,0,0-4.459,1.162v12.988a.677.677,0,0,1-.647.678h-2.971a.677.677,0,0,1-.647-.678v-16.9a.649.649,0,0,1,.647-.647h2.81a.648.648,0,0,1,.647.647v.678a7.518,7.518,0,0,1,4.62-1.551.647.647,0,0,1,.646.646v2.326A.648.648,0,0,1,291.183,299.727Z",
    transform: "translate(-36.897 -33.279)",
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M315.992,314.814a26.779,26.779,0,0,1-5.782-.646.731.731,0,0,1-.614-.743v-1.939a.538.538,0,0,1,.549-.517h.13c1.551.195,4.458.356,5.427.356,2,0,2.293-.678,2.293-1.551,0-.614-.387-1-1.421-1.647l-4.426-2.713a5.324,5.324,0,0,1-2.713-4.459c0-3.23,2.035-4.846,6.138-4.846a23.957,23.957,0,0,1,5.751.646.7.7,0,0,1,.582.743v1.874c0,.387-.195.614-.517.614h-.13a47.427,47.427,0,0,0-5.33-.388c-1.551,0-2.229.355-2.229,1.357,0,.517.485.84,1.292,1.325l4.232,2.584c2.714,1.648,3.1,3.262,3.1,4.909C322.323,312.585,320.224,314.814,315.992,314.814Z",
    transform: "translate(-52.4 -33.279)",
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(275.008 256.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M359.014,289.933c2.667,0,3.908,1.5,3.908,4.716v11.09a.375.375,0,0,0,.374.374h1.617a.374.374,0,0,0,.373-.374V294.65c0-4.39-1.994-6.71-5.766-6.71a13.861,13.861,0,0,0-5.036,1.021l-.422.185v-7.4a.351.351,0,0,0-.341-.374h-1.685a.351.351,0,0,0-.34.374v24a.372.372,0,0,0,.34.374h1.652a.4.4,0,0,0,.374-.374V290.984l.176-.08A13.45,13.45,0,0,1,359.014,289.933Z",
    transform: "translate(-351.697 -281.366)",
    fill: "#5d5c5c"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(293.165 263.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M401.573,296.822c-4.5,0-7.182,2.837-7.182,7.587v3.034c0,6.438,4,7.789,7.351,7.789a30.276,30.276,0,0,0,5.976-.569c.4-.074.43-.184.43-.479v-1.146c0-.046,0-.171-.239-.171h-.168a45.948,45.948,0,0,1-6,.37c-3.449,0-4.987-1.787-4.987-5.8v-.774h11.593c.28,0,.339-.239.339-.44v-1.82C408.688,299.587,406.095,296.822,401.573,296.822Zm4.716,8.191h-9.534v-.6c0-4.623,2.62-5.593,4.818-5.593,3.262,0,4.716,1.725,4.716,5.593Z",
    transform: "translate(-394.391 -296.822)",
    fill: "#5d5c5c"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    transform: "translate(311.455 263.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M445.221,304.508c-5.556,0-7.823,1.494-7.823,5.159v.405c0,4.265,2.824,5.16,5.193,5.16a9.829,9.829,0,0,0,5.04-1.612l.452-.264v1.265a.374.374,0,0,0,.373.374h1.552a.374.374,0,0,0,.373-.374V302.858c0-4.061-2.052-6.036-6.273-6.036a28.742,28.742,0,0,0-5.174.434c-.458.067-.458.233-.458.344v1.18c0,.128,0,.238.306.238h.169a48.692,48.692,0,0,1,5.157-.27c2.812,0,3.908,1.152,3.908,4.11v1.65Zm-2.057,8.9c-2.384,0-3.4-1.007-3.4-3.368v-.4c0-2.7,1.378-3.605,5.458-3.605h2.8v5.908l-.158.085A9.516,9.516,0,0,1,443.164,313.407Z",
    transform: "translate(-437.398 -296.822)",
    fill: "#5d5c5c"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(329.963 256.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M481.225,281.366a.314.314,0,0,0-.306.339v24.034a.345.345,0,0,0,.306.374h1.753c.21,0,.306-.219.306-.374V281.705a.313.313,0,0,0-.306-.339Z",
    transform: "translate(-480.919 -281.366)",
    fill: "#5d5c5c"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(336.403 259.121)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M496.4,291.637a.3.3,0,0,0-.339.3v.911c0,.067,0,.273.367.307l3.544.4v12.033c0,3.586,1.382,4.217,4.283,4.217a16.129,16.129,0,0,0,2.146-.166c.351-.054.351-.177.351-.276V308.19c0-.076,0-.171-.407-.171h-1.888c-1.467,0-2.121-.35-2.121-2.425V293.53h3.941a.375.375,0,0,0,.374-.374V292.01a.374.374,0,0,0-.374-.373h-3.941v-3.975c0-.171-.1-.273-.205-.273h-.1l-1.707.267a.386.386,0,0,0-.352.376v3.605Z",
    transform: "translate(-496.061 -287.389)",
    fill: "#5d5c5c"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151",
    transform: "translate(350.832 256.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M537.307,289.933c2.666,0,3.908,1.5,3.908,4.716v11.09a.375.375,0,0,0,.374.374h1.618a.374.374,0,0,0,.373-.374V294.65c0-4.39-1.994-6.71-5.766-6.71a13.865,13.865,0,0,0-5.037,1.021l-.422.185v-7.4a.35.35,0,0,0-.34-.374H530.33a.351.351,0,0,0-.34.374v24a.372.372,0,0,0,.34.374h1.651a.4.4,0,0,0,.374-.374V290.984l.177-.08A13.455,13.455,0,0,1,537.307,289.933Z",
    transform: "translate(-529.99 -281.366)",
    fill: "#5d5c5c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIprsLogo);
export default __webpack_public_path__ + "static/media/iprs-logo.18905e20fca715c3f5be07ce47025b94.svg";
export { ForwardRef as ReactComponent };